import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includedIn'
})
export class IncludedInPipe implements PipeTransform {
  transform(value: any, searchArray: any[]): any {
    return searchArray.includes(value);
  }
}
